import { DownloadOutlined } from '@ant-design/icons';
import { Idea } from '@frontend/data-access';
import { Button, Modal, Tooltip } from 'antd';
import { useRef, useState } from 'react';
import { IdeaBasics } from './basics';
import IdeaContents from './idea-contents';
import { useReactToPrint } from 'react-to-print';
import useTranslation from 'next-translate/useTranslation';

function IdeaChannelPdfDownload({ idea }: { idea: Idea }) {
  const { t } = useTranslation('common');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const targetRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({
    contentRef: targetRef,
    documentTitle: `${idea.name}.pdf`,
  });

  const handleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <>
      <Tooltip title={t('download_pdf')}>
        <Button shape="round" onClick={handleModal}>
          <DownloadOutlined />
        </Button>
      </Tooltip>
      <Modal
        open={isModalOpen}
        closeIcon={null}
        onCancel={handleModal}
        title={
          <div className="flex items-center justify-between">
            <div>{t('pdf_preview')}</div>
            <div className="flex flex-row space-x-2 items-center">
              <Button
                type="primary"
                shape="round"
                onClick={() => reactToPrintFn()}
              >
                <DownloadOutlined />
                {t('save_pdf')}
              </Button>
              <Button shape="round" onClick={handleModal}>
                {t('close')}
              </Button>
            </div>
          </div>
        }
        width={1106}
        footer={false}
        centered
      >
        <div className="mt-6 border border-gray-300 rounded-md">
          <div ref={targetRef} className="p-6" aria-readonly>
            <div className="grid md:grid-cols-3">
              <div className="col-span-2">
                <IdeaContents ideaId={idea?.id} printMode />
              </div>
              <div className="col-span-1">
                <IdeaBasics ideaId={idea?.id} isPrinting={true} />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default IdeaChannelPdfDownload;
